import React from 'react'
import RewardsComponent from '../components/Rewards/RewardsComponent';

const Rewards:React.FC = () => {
  return (
    <>
    <RewardsComponent/>
    </>
  )
}

export default Rewards;